import DictionaryIcon_Trans from "../../../assets/UI/DictionaryIcon_Trans.png";
import SearchBarDictionary from "../DictionaryComponents/SearchBar_Dictionary/SearchBar_Dictionary";
import "../Dictionary.css";
import HeaderNavNTM from "../../../Components/Header/Header_Nav_NoBottomMargin/Header_Nav_NBM";
import WordGrid from "../DictionaryComponents/WordGrid/WordGrid";
import { useState } from "react";
import Popup from "../../../Components/Popup/Dictionary_Popup";

import { NAT_NUM_0_10 } from "../../../SubjectData/BasicWords/Numbers/NatNums";
import { NAT_NUM_11_19} from "../../../SubjectData/BasicWords/Numbers/NatNums";
import { NAT_NUM_20_29} from "../../../SubjectData/BasicWords/Numbers/NatNums";
import { NAT_NUM_30_39} from "../../../SubjectData/BasicWords/Numbers/NatNums";
import { NAT_NUM_40_49} from "../../../SubjectData/BasicWords/Numbers/NatNums";
import { NAT_NUM_50_59 } from "../../../SubjectData/BasicWords/Numbers/NatNums";
import { NAT_NUM_60_69 } from "../../../SubjectData/BasicWords/Numbers/NatNums";
import { NAT_NUM_70_79 } from "../../../SubjectData/BasicWords/Numbers/NatNums";
import { NAT_NUM_80_89 } from "../../../SubjectData/BasicWords/Numbers/NatNums";
import { NAT_NUM_90_99 } from "../../../SubjectData/BasicWords/Numbers/NatNums";
import { NAT_NUM_100_900 } from "../../../SubjectData/BasicWords/Numbers/NatNums";
import { NAT_NUM_1000_9000 } from "../../../SubjectData/BasicWords/Numbers/NatNums";
import { NAT_NUM_10000_PLUS } from "../../../SubjectData/BasicWords/Numbers/NatNums";

import { SINO_NUM_0_10 } from "../../../SubjectData/BasicWords/Numbers/SinoNums";
import { SINO_NUM_11_19 } from "../../../SubjectData/BasicWords/Numbers/SinoNums";
import { SINO_NUM_20_29 } from "../../../SubjectData/BasicWords/Numbers/SinoNums";
import { SINO_NUM_30_39 } from "../../../SubjectData/BasicWords/Numbers/SinoNums";
import { SINO_NUM_40_49 } from "../../../SubjectData/BasicWords/Numbers/SinoNums";
import { SINO_NUM_50_59 } from "../../../SubjectData/BasicWords/Numbers/SinoNums";
import { SINO_NUM_60_69 } from "../../../SubjectData/BasicWords/Numbers/SinoNums";
import { SINO_NUM_70_79 } from "../../../SubjectData/BasicWords/Numbers/SinoNums";
import { SINO_NUM_80_89 } from "../../../SubjectData/BasicWords/Numbers/SinoNums";
import { SINO_NUM_90_99 } from "../../../SubjectData/BasicWords/Numbers/SinoNums";
import { SINO_NUM_100_900 } from "../../../SubjectData/BasicWords/Numbers/SinoNums";
import { SINO_NUM_1000_9000 } from "../../../SubjectData/BasicWords/Numbers/SinoNums";
import { SINO_NUM_10000_PLUS } from "../../../SubjectData/BasicWords/Numbers/SinoNums";


export default function NumbersDictionary(){

    const [openPopup, setOpenPopup] = useState(null);
    
    const allData = [

                    //Native Number Arrays
                    ...NAT_NUM_0_10,
                    ...NAT_NUM_11_19,
                    ...NAT_NUM_20_29,
                    ...NAT_NUM_30_39,
                    ...NAT_NUM_40_49,
                    ...NAT_NUM_50_59,
                    ...NAT_NUM_60_69,
                    ...NAT_NUM_70_79,
                    ...NAT_NUM_80_89,
                    ...NAT_NUM_90_99,
                    ...NAT_NUM_100_900,
                    ...NAT_NUM_1000_9000,
                    ...NAT_NUM_10000_PLUS,

                    //Sino Number Arrays

                    ...SINO_NUM_0_10,
                    ...SINO_NUM_11_19,
                    ...SINO_NUM_20_29,
                    ...SINO_NUM_30_39,
                    ...SINO_NUM_40_49,
                    ...SINO_NUM_50_59,
                    ...SINO_NUM_50_59,
                    ...SINO_NUM_60_69,
                    ...SINO_NUM_70_79,
                    ...SINO_NUM_80_89,
                    ...SINO_NUM_90_99,
                    ...SINO_NUM_100_900,
                    ...SINO_NUM_1000_9000,
                    ...SINO_NUM_10000_PLUS
                    
                    ];

    return(

        <div>
            <HeaderNavNTM GoBack_to="/NumbersNav"/>
            <div   className="blue-header-dict">
                
                <img className="DictionaryImage" src={DictionaryIcon_Trans} alt="Dictionary"></img>
               
                <SearchBarDictionary data={allData} onSelectItem={setOpenPopup}/>
                
            </div>
            <div className="deck-title-dict"><h1 className="deck-title-txt-dict">Numbers (숫자)</h1></div>

            <div>
                <h1 className="wordgrid-subheader">Native Numbers (고유어 수) </h1>
                    <div className="word-grid-subject-container">
                        <WordGrid data={NAT_NUM_0_10} title="0-10" onSelectItem={setOpenPopup}/>
                        <WordGrid data={NAT_NUM_11_19} title="11-19" onSelectItem={setOpenPopup}/>
                        <WordGrid data={NAT_NUM_20_29} title="20-29" onSelectItem={setOpenPopup}/>
                        <WordGrid data={NAT_NUM_30_39} title="30-39" onSelectItem={setOpenPopup}/>
                        <WordGrid data={NAT_NUM_40_49} title="40-49" onSelectItem={setOpenPopup}/>
                        <WordGrid data={NAT_NUM_50_59} title="50-59" onSelectItem={setOpenPopup}/>
                        <WordGrid data={NAT_NUM_60_69} title="60-69" onSelectItem={setOpenPopup}/>
                        <WordGrid data={NAT_NUM_70_79} title="70-79" onSelectItem={setOpenPopup}/>
                        <WordGrid data={NAT_NUM_80_89} title="80-89" onSelectItem={setOpenPopup}/>
                        <WordGrid data={NAT_NUM_90_99} title="90-99" onSelectItem={setOpenPopup}/>
                        <WordGrid data={NAT_NUM_100_900} title="100-900" onSelectItem={setOpenPopup}/>
                        <WordGrid data={NAT_NUM_1000_9000} title="1000-9000" onSelectItem={setOpenPopup}/>
                        <WordGrid data={NAT_NUM_10000_PLUS} title="10000+" onSelectItem={setOpenPopup}/>
                    </div>

                <h1 className="wordgrid-subheader">Sino Numbers (한자어 수)</h1>
                <div className="word-grid-subject-container">
                        <WordGrid data={SINO_NUM_0_10} title="0-10" onSelectItem={setOpenPopup}/>
                        <WordGrid data={SINO_NUM_11_19} title="11-19" onSelectItem={setOpenPopup}/>
                        <WordGrid data={SINO_NUM_20_29} title="20-29" onSelectItem={setOpenPopup}/>
                        <WordGrid data={SINO_NUM_30_39} title="30-39" onSelectItem={setOpenPopup}/>
                        <WordGrid data={SINO_NUM_40_49} title="40-49" onSelectItem={setOpenPopup}/>
                        <WordGrid data={SINO_NUM_50_59} title="50-59" onSelectItem={setOpenPopup}/>
                        <WordGrid data={SINO_NUM_60_69} title="60-69" onSelectItem={setOpenPopup}/>
                        <WordGrid data={SINO_NUM_70_79} title="70-79" onSelectItem={setOpenPopup}/>
                        <WordGrid data={SINO_NUM_80_89} title="80-89" onSelectItem={setOpenPopup}/>
                        <WordGrid data={SINO_NUM_90_99} title="90-99" onSelectItem={setOpenPopup}/>
                        <WordGrid data={SINO_NUM_100_900} title="100-900" onSelectItem={setOpenPopup}/>
                        <WordGrid data={SINO_NUM_1000_9000} title="1000-9000" onSelectItem={setOpenPopup}/>
                        <WordGrid data={SINO_NUM_10000_PLUS} title="10000+" onSelectItem={setOpenPopup}/>
                </div>
                <Popup item={openPopup} onClose={() => setOpenPopup(null)} />

            </div>

        </div>

    );

}


//Resources
    //Making a search bar
        //https://builtin.com/articles/react-search-bar